module.exports = __webpack_public_path__ + "static/media/Slide20.9fa34281.JPG";